import React from "react";
import { FormattedMessage, FormattedTime } from "react-intl";
import { setZeroTimezoneOffset } from "@trainline-shareable/utils";
import useJourneyContext from "../../hooks/useJourneyContext";
import LoadingSkeleton from "../LoadingSkeleton";
const RELEVANT_TIME_STATUS = ["DELAYED", "LATE", "ONTIME"];
const LiveTimeStatus = ({ callingPoint, type = "departure" }) => {
  var _a, _b;
  const { isInitializing } = useJourneyContext();
  if (isInitializing) {
    return /* @__PURE__ */ React.createElement(LoadingSkeleton, {
      style: { height: "14px" }
    });
  }
  const data = type === "departure" ? callingPoint == null ? void 0 : callingPoint.departure : callingPoint == null ? void 0 : callingPoint.arrival;
  if (data) {
    const status = (_a = data.realTime) == null ? void 0 : _a.status;
    const time = (_b = data.realTime) == null ? void 0 : _b.time;
    if (!status || !RELEVANT_TIME_STATUS.includes(status)) {
      return null;
    }
    if (status === "DELAYED") {
      return /* @__PURE__ */ React.createElement(FormattedMessage, {
        id: "liveTracker.timeStatus.delayed"
      });
    }
    if (status === "LATE") {
      return time ? /* @__PURE__ */ React.createElement(FormattedTime, {
        value: new Date(setZeroTimezoneOffset(time)),
        hour: "numeric",
        minute: "numeric",
        hour12: false,
        timeZone: "UTC"
      }) : null;
    }
    return /* @__PURE__ */ React.createElement(FormattedMessage, {
      id: "liveTracker.timeStatus.onTime"
    });
  }
  return null;
};
var LiveTimeStatus_default = LiveTimeStatus;
export {
  LiveTimeStatus_default as default
};
